
import TileLayer from 'ol/layer/Tile'
import TileWMS   from "ol/source/TileWMS";


//const geoserver ="http://218.241.129.181:8010/geoserver/DZZH/wms";
// const geoserver ="http://47.114.180.160:8060/zdha_geoserver/geoserver/DZZH/wms";
const geoserver ="/zdha_geoserver/geoserver/DZZH/wms";
const LayerSource_shandong=[
  {
    title:'监测台站分布',
    visible:false,
    layerCode:'DZZH:20071508',
    geoserver:geoserver
  },
  {
    //中石油的西气东输项目
    title:'西气东输管线缓冲_PIPBUFFER',
    visible:false,
    layerCode:'DZZH:shandong_pipeline_buffer',
    geoserver:geoserver
  },

  {
    title:'西气东输站厂阀室_SKJY',
    visible:false,
    layerCode:'DZZH:xqdsrainfallmonitoringsite_sd',
    geoserver:geoserver
  },
  {
    title:'西气东输站厂阀室_FCTS',
    visible:false,
    layerCode:'DZZH:xqdsrainfallmonitoringsite_sd',
    geoserver:geoserver
  },
];



const LayerSource_xqds=[
  {
    title:'监测台站分布',
    visible:false,
    layerCode:'DZZH:20071508',
    geoserver:geoserver
  },
  {
    //中石油的西气东输项目
    title:'西气东输管线缓冲_PIPBUFFER',
    visible:false,
    layerCode:'DZZH:shandong_pipeline_buffer',
    geoserver:geoserver
  },

  {
    title:'西气东输站厂阀室_SKJY',
    visible:false,
    layerCode:'DZZH:xqdsrainfallmonitoringsite',
    geoserver:geoserver
  },
  {
    title:'西气东输站厂阀室_FCTS',
    visible:false,
    layerCode:'DZZH:xqdsrainfallmonitoringsite',
    geoserver:geoserver
  },
];



export function loadWMS(visible,server,layercode,layername) {

  let tileLayer = new TileLayer({
    name:layername,
    visible:visible,
    source: new TileWMS({
      crossOrigin:'anonymous',
      url: server,
      params: {
        'LAYERS': layercode,
        'TILED': true,
      },
      serverType: 'geoserver',
      transition: 1
    }),

  });
  //alert("223");
  //set layer name
  tileLayer.name = layername;
  return tileLayer;
}

/**
 * 读取Geoserver文件中的地图图层  && 默认为山东管网数据
 * */
function getLayerSource(appkey)
{
  let LayerSource = [];
  if(appkey=="xqds"){
    LayerSource = LayerSource_xqds;
  }else{
    LayerSource = LayerSource_shandong;
  }

  let geoLayers = [];
  LayerSource.forEach(item=>{
    const tileLayer = new TileLayer({
      visible:item.visible,
      source: new TileWMS({
        crossOrigin:'anonymous',
        url: item.geoserver,
        params: {
          'LAYERS': item.layerCode,
          'TILED': true,
        },
        serverType: 'geoserver',
        transition: 1
      })
    });
    //set layer name
    tileLayer.name = item.title;
    geoLayers.push(tileLayer);
  });
  return geoLayers;
}
/**
 * Module Export
 * */
export default getLayerSource;





// WEBPACK FOOTER //
// ./src/components/map/common/layerSource.js